import React from 'react'
import { Typography, Row, Col, Divider, Image } from 'antd'
import banner from '../assets/banner.jpg'
import logo3 from '../assets/logo3.png'
import aboutIcon from '../assets/aboutIcon.png'
// import fallback from '../assets/fallback.png'


function About() {
  return (
    <div>
      <Row>
        <Col offset={1} span={22}>
          <div>
            <img style={{ height: 500, width: '100%', borderRadius: '0px 0px 0px 50px' }} src={banner} alt='house banner' />
            <Typography.Title level={1} style={{ position: 'absolute', top: '42%', left: '10%', color: '#FFFFFF', backgroundColor: '#FD3200', padding: 20, borderRadius: '10px', fontSize: 48 }}>
              {`Welcome to`}
            </Typography.Title>
            <Typography.Title level={1} style={{ position: 'absolute', top: '55%', left: '10%', color: '#FFFFFF', backgroundColor: '#FD3200', padding: 20, borderRadius: '10px', fontSize: 48 }}>
              {`the Block`}
            </Typography.Title>
          </div>
        </Col>
      </Row>

      <Row>
        <Image src={logo3} preview={false} alt='logo' style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto', marginTop: 25, width: '30%' }} />
      </Row>


      <Row>
        <Col offset={3} span={18}>
          <Typography.Title style={{ color: '#001B71', marginBottom: 50, marginTop: 50, textAlign: 'center' }} level={3}>
            Mercata Properties is a digital marketplace that revolutionizes the process of buying and selling real estate properties, aiming to <text style={{ color: '#FD3200' }}>accelerate property sales while reducing overall expenses.</text>
          </Typography.Title>
          <Typography.Title style={{ color: '#001B71', marginBottom: 50, textAlign: 'center' }} level={3}>
            By leveraging the  <text style={{ color: '#3452FF' }}>transparency, security, and efficiency</text> of blockchain technology, Mercata Properties streamlines the transaction process, enhances trust among participants, and lowers costs associated with traditional real estate transactions.
          </Typography.Title>
        </Col>
      </Row>

      <Row style={{ backgroundColor: '#001B71', paddingBottom: 40 }}>
        <Col offset={4} span={5}>
          <p style={{ fontSize: 50, marginBottom: 10 }}>⏱️</p>
          <Typography.Title style={{ color: '#FFFFFF' }} level={4}>Faster time to close</Typography.Title>
          <Typography.Paragraph style={{ color: '#FFFFFF' }}>
            Buyers can make offers directly through the platform, eliminating the need for intermediaries and reducing negotiation periods.
          </Typography.Paragraph>
        </Col>
        <Col offset={1} span={5}>
          <p style={{ fontSize: 50, marginBottom: 10 }}>💳</p>
          <Typography.Title style={{ color: '#FFFFFF' }} level={4}>Lower fees</Typography.Title>
          <Typography.Paragraph style={{ color: '#FFFFFF' }}>
            Sellers can save on agent commissions, while buyers benefit from lower fees associated with title searches, escrow services, and legal documentation.
          </Typography.Paragraph>
        </Col>
        <Col offset={1} span={5}>
          <p style={{ fontSize: 50, marginBottom: 10 }}>🤝</p>
          <Typography.Title style={{ color: '#FFFFFF' }} level={4}>Increased trust</Typography.Title>
          <Typography.Paragraph style={{ color: '#FFFFFF' }}>
            Property information, ownership records, and transaction history are securely stored and easily accessible, minimizing fraud risks and improving confidence in the transaction process.
          </Typography.Paragraph>
        </Col>
      </Row>

      <Row>
        <Col offset={4} span={7} style={{ marginTop: 20 }}>
          <Typography.Title style={{ textAlign: 'center', color: '#001B71' }} level={2}>Current Process</Typography.Title>
          <Typography.Paragraph style={{ textAlign: 'center' }}>
            The real estate industry suffers from significant inefficiencies, lengthy transaction cycles, and high costs. Traditional property sales involve multiple intermediaries, complex paperwork, and limited transparency, leading to delays, disputes, and inflated expenses. Sellers face high fees and a lengthy sales process, while buyers struggle with verifying property ownership and ensuring a smooth transfer of assets.
          </Typography.Paragraph>
          <Typography.Title style={{ textAlign: 'center', color: '#001B71' }} level={4}>
            1. Bids placed through seller’s and buyer’s agents
          </Typography.Title>
          <Typography.Title style={{ textAlign: 'center', color: '#001B71' }} level={4}>
            2. Purchase agreement and closing documents signed and stored in a binder
          </Typography.Title>
          <Typography.Title style={{ textAlign: 'center', color: '#001B71' }} level={4}>
            3. Seller pays 6%* agent commission
          </Typography.Title>
          <Typography.Paragraph style={{ display: 'flex', justifyContent: 'flex-end', fontSize: '11px' }}>
            3% to seller’s agent, 3% to buyer’s agent*
          </Typography.Paragraph>
        </Col>
        <Col offset={2} span={7} style={{ marginTop: 20 }}>
          <Typography.Title style={{ textAlign: 'center', color: '#FB3200' }} level={2}>With Mercata Properties</Typography.Title>
          <Typography.Paragraph style={{ textAlign: 'center' }}>
            Mercata Properties provides a secure and transparent platform for buying and selling real estate properties. Using smart contracts and distributed ledger technology, we automate and streamline key stages of the transaction process, including property listings, due diligence, escrow services, and transfer of ownership. Participants can access a user-friendly interface to browse listings, submit offers, and track the progress of their transactions in real-time.
          </Typography.Paragraph>

          <Typography.Title style={{ textAlign: 'center', color: '#001B71' }} level={4}>
            1. Bids placed <text style={{ color: '#FD3200' }}>directly to seller</text> on the Mercata platform
          </Typography.Title>
          <Typography.Title style={{ textAlign: 'center', color: '#001B71' }} level={4}>
            2. Purchase agreement and closing documents <text style={{ color: '#FD3200' }}>signed and stored on-chain,</text> referenceable and accessible for subsequent sales
          </Typography.Title>

          <Typography.Title style={{ textAlign: 'center', color: '#001B71' }} level={4}>
            3. Seller pays <text style={{ color: '#FD3200' }}>2-4%*</text> agent commission
          </Typography.Title>

          <Typography.Paragraph style={{ display: 'flex', justifyContent: 'flex-end', fontSize: '11px' }}>
            1% to Mercata, 3% to buyer’s agent*
          </Typography.Paragraph>
        </Col>
      </Row>

    <Divider />

      <Row style={{ marginTop: 50 }}>
        <Col offset={3} span={10} style={{ display: 'in-line' }}>
          <Typography.Title level={1} style={{ textAlign: 'center', color: '#FB3200' }}>About BlockApps</Typography.Title>
          <Typography.Title level={4} style={{ textAlign: 'center', color: '#001B71' }}>
            Mercata Properties is powered by BlockApps, the leader in Web3 Commerce for Business. BlockApps helps deliver greater transparency and trust to transactions in order to unlock the value of business assets and deepen customer understanding of products to make better buying decisions.
          </Typography.Title>
        </Col>
        <Col span={11} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Image
            style={{ width: '80%' }}
            src={aboutIcon}
            preview={false}
          />
        </Col>
      </Row>
    </div>
  )
}

export default About